export const PAD_CARD_TYPES = {
  VISIT: 'VISIT',
  DIAGNOSTIC: 'DIAGNOSTIC',
  ITEM: 'ITEM',
  PRESCRIPTION: 'PRESCRIPTION'
};

export const PAD_ALTERATION_TYPE = {
  CREATION: 1,
  ALTERATION: 2,
  SUSPENSION: 3
};

export const PRESCRIPTION_TYPE = {
  EVALUATIONS: 1,
  DIET: 2,
  MEDS: 3,
  PROCEDURES: 4,
  NANDAPROCEDURE: 5
};
